export { loadMap } from './mapInit';
